<span class="ant-table-column-title">
  <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
</span>
<ng-container *ngIf="!customFilter; else extraTemplate">
  <ui-filter-trigger [uiVisible]="isVisible" [uiActive]="isChecked" [uiDropdownMenu]="filterMenu" (uiVisibleChange)="onVisibleChange($event)">
    <ui-icon uiType="filter" uiTheme="fill"></ui-icon>
  </ui-filter-trigger>
  <ui-dropdown-menu #filterMenu="uiDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <ul ui-menu>
        <li ui-menu-item [uiSelected]="f.checked" *ngFor="let f of listOfParsedFilter; trackBy: trackByValue" (click)="check(f)">
          <label ui-radio *ngIf="!filterMultiple" [ngModel]="f.checked" (ngModelChange)="check(f)"></label>
          <label ui-checkbox *ngIf="filterMultiple" [ngModel]="f.checked" (ngModelChange)="check(f)"></label>
          <span>{{ f.text }}</span>
        </li>
      </ul>
      <div class="ant-table-filter-dropdown-btns">
        <button ui-button uiType="link" uiSize="small" (click)="reset()" [disabled]="!isChecked">
          {{ locale.filterReset }}
        </button>
        <button ui-button uiType="primary" uiSize="small" (click)="confirm()">{{ locale.filterConfirm }}</button>
      </div>
    </div>
  </ui-dropdown-menu>
</ng-container>
